module.exports = __webpack_public_path__ + "images/preview_large@3x.png?44b41528";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview_large@3x.png
// module id = 688
// module chunks = 7